/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
// @ts-ignore
import { Skeleton } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'

const WaveLoading = () => {
  const mode = useDisplayTheme()
  return <Skeleton variation="rectangle" mode={mode} animation="wave" />
}

export default WaveLoading
